import axios from "axios";
const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export async function getTopbarOffers() {
  const res = await axios.get(API_BASE + "/topbar-offers");
  return res.data.offers || [];
}
